export default __webpack_public_path__ + "static/media/Niramit-Regular.4000398d.ttf";